import { render, staticRenderFns } from "./HistoryPickupDetail.vue?vue&type=template&id=ca83dfe8&scoped=true&"
import script from "./HistoryPickupDetail.vue?vue&type=script&lang=js&"
export * from "./HistoryPickupDetail.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPickupDetail.vue?vue&type=style&index=0&id=ca83dfe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca83dfe8",
  null
  
)

export default component.exports